/**
 * @generated SignedSource<<32e20930337bf9b74beb03fd05f3840f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CrawlRunScope = "ALL_SITES" | "SINGLE_SITE" | "%future added value";
export type CrawlRunStatus = "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "QUEUED" | "RUNNING" | "%future added value";
export type CrawlTrigger = "MANUAL" | "NIGHTLY" | "%future added value";
export type crawlRunsQuery$variables = Record<PropertyKey, never>;
export type crawlRunsQuery$data = {
  readonly crawlRuns: ReadonlyArray<{
    readonly completedUtc: any | null | undefined;
    readonly id: any;
    readonly listingsAdded: number;
    readonly listingsDelisted: number;
    readonly listingsMissed: number;
    readonly listingsUnchanged: number;
    readonly listingsUpdated: number;
    readonly rejectsQueued: number;
    readonly requestedByOperator: string;
    readonly requestedUtc: any;
    readonly scope: CrawlRunScope;
    readonly siteId: any | null | undefined;
    readonly sitesCrawled: number;
    readonly sitesPartiallyCrawled: number;
    readonly startedUtc: any | null | undefined;
    readonly status: CrawlRunStatus;
    readonly trigger: CrawlTrigger;
  }>;
};
export type crawlRunsQuery = {
  response: crawlRunsQuery$data;
  variables: crawlRunsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CrawlRunSummary",
    "kind": "LinkedField",
    "name": "crawlRuns",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "trigger",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestedByOperator",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scope",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siteId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestedUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startedUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sitesCrawled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sitesPartiallyCrawled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsAdded",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsUpdated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsUnchanged",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsMissed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsDelisted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectsQueued",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "crawlRunsQuery",
    "selections": (v0/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "crawlRunsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6825e8b619ad3e38f9db95131cd17049",
    "id": null,
    "metadata": {},
    "name": "crawlRunsQuery",
    "operationKind": "query",
    "text": "query crawlRunsQuery {\n  crawlRuns {\n    id\n    trigger\n    requestedByOperator\n    scope\n    siteId\n    status\n    requestedUtc\n    startedUtc\n    completedUtc\n    sitesCrawled\n    sitesPartiallyCrawled\n    listingsAdded\n    listingsUpdated\n    listingsUnchanged\n    listingsMissed\n    listingsDelisted\n    rejectsQueued\n  }\n}\n"
  }
};
})();

(node as any).hash = "1763f01dcd8d9a11a0082b028ebe715b";

export default node;
